export default __webpack_public_path__ + "static/img/wp_contact_1.10776c7.jpg";